var render, staticRenderFns
import script from "./draw-canvas.vue?vue&type=script&lang=js"
export * from "./draw-canvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58d798",
  null
  
)

export default component.exports